import { Alert, AlertTitle } from "@mui/material";
import { PAYMENT_CONFLICT } from "utils/pendingPaymentChange";
import { formatDisplayDateTime } from "utils/dateFormat";

const TITLES = {
  [PAYMENT_CONFLICT.UPDATED]: "This payment was updated",
  [PAYMENT_CONFLICT.VERIFIED]: "Already approved",
  [PAYMENT_CONFLICT.REJECTED]: "Already rejected",
  [PAYMENT_CONFLICT.WITHDRAWN]: "Withdrawn",
};

const SEVERITY = {
  [PAYMENT_CONFLICT.UPDATED]: "warning",
  [PAYMENT_CONFLICT.VERIFIED]: "info",
  [PAYMENT_CONFLICT.REJECTED]: "error",
  [PAYMENT_CONFLICT.WITHDRAWN]: "info",
};

/** Explains why a payment action was refused: who changed the payment, when, and what to do next. */
const PaymentConflictAlert = ({ conflict, sx }) => {
  if (!conflict) return null;
  const when = conflict.changedAt ? formatDisplayDateTime(conflict.changedAt, null) : null;
  return (
    <Alert severity={SEVERITY[conflict.code] || "warning"} sx={sx}>
      <AlertTitle>
        {TITLES[conflict.code] || "This payment changed"}
        {when ? ` · ${when}` : ""}
      </AlertTitle>
      {conflict.message}
    </Alert>
  );
};

export default PaymentConflictAlert;
